import { withResultContainer } from '@bingads-webui-react/hoc-with-multi-selector-result-container';
import { withDropdownMenu } from '@bingads-webui-react/hoc-with-dropdown-menu';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getMultiCampaignAgroupSelectorStyle } from './styles/multi-campaign-adgroup-selector-style';

import { OriginCampaignAdgroupSelector } from './origin-campaign-adgroup-selector';

export const SingleCampaignAdgroupSelector = withDropdownMenu(OriginCampaignAdgroupSelector);
export const MultiCampaignAdgroupSelector = withDefaultStyles(
  withDropdownMenu(withResultContainer(OriginCampaignAdgroupSelector)),
  getMultiCampaignAgroupSelectorStyle
);
